<template>
	<div>
		<!-- 外观 -->
		<div class="wjappearance">
			<!-- 左侧盒子  -->
			<div class="wjAppearance_left">
				<!-- 主颜色 -->
				<div class="wjColor_box">
					<div class="wjColor_children" v-for="(item, index) in resultBody" :key="index">
						<div v-if="index == 0">
							<p style="font-size: 16px; color: #333">{{ item.appearanceName }}</p>
							<div class="color_btn_box" v-if="tabPosition != 'phone'">
								<button
									v-for="(childItem, childIndex) in item.questionnaireAppearanceList"
									:key="childIndex"
									:style="{ backgroundColor: childItem.appearanceName }"
									@click="btnColor(childIndex, childItem)"
								>
									<i class="el-icon-check" v-show="childItem.appearanceName == style.subjectColor"></i>
								</button>
							</div>

							<div class="color_btn_box" v-if="tabPosition == 'phone'">
								<button
									v-for="(childItem, childIndex) in item.questionnaireAppearanceList"
									:key="childIndex"
									:style="{ backgroundColor: childItem.appearanceName }"
									@click="btnColorPhone(childIndex, childItem)"
								>
									<i class="el-icon-check" v-show="childItem.appearanceName == stylePhone.subjectColor"></i>
								</button>
							</div>
						</div>
					</div>
				</div>
				<!-- 动态默认分类 -->
				<div style="margin-top: 10px" v-if="tabPosition != 'phone'">
					<div v-for="(item, index) in resultBody" :key="index">
						<div v-if="index != 0" class="drop-down-display">
							<el-collapse v-model="activeName" accordion>
								<el-collapse-item :title="item.appearanceName" :name="index">
									<div style="width: 278px" v-for="(childItem, childIndex) in item.questionnaireAppearanceList" :key="childIndex">
										<img :src="childItem.appearanceUrl" alt="" class="classified_pictures" @click="imgSet(childItem.appearanceUrl)" />
									</div>
								</el-collapse-item>
							</el-collapse>
						</div>
					</div>
				</div>

				<div style="margin-top: 10px" v-if="tabPosition == 'phone'">
					<div v-for="(item, index) in resultBody" :key="index">
						<div v-if="index != 0" class="drop-down-display">
							<el-collapse v-model="activeName" accordion>
								<el-collapse-item :title="item.appearanceName" :name="index">
									<div style="width: 278px" v-for="(childItem, childIndex) in item.questionnaireAppearanceList" :key="childIndex">
										<img :src="childItem.appearanceUrl" alt="" class="classified_pictures" @click="imgSetPhone(childItem.appearanceUrl)" />
									</div>
								</el-collapse-item>
							</el-collapse>
						</div>
					</div>
				</div>
			</div>

			<div class="wjAppearance_center">
				<div class="tab">
					<el-radio-group v-model="tabPosition" @change="tabChange">
						<el-radio-button label="phone">
							<i class="el-icon-mobile-phone"></i>
							{{$t('Appearance.MobilePhone')}}
						</el-radio-button>
						<el-radio-button label="computer">
							<i class="el-icon-monitor"></i>
							{{$t('Appearance.Computer')}}
						</el-radio-button>
					</el-radio-group>
				</div>
				<div class="phoneBox flex justify-content" v-if="tabPosition == 'phone'">
					<div class="phone-bj">
						<div class="phone-bj-box">
							<UserAnswer :styleData="styleData" :isPreviewPc="1" :key="1"></UserAnswer>
						</div>
					</div>
				</div>
				<div class="computerBox" v-if="tabPosition == 'computer'">
					<div class="computer-bj">
						<UserAnswer :styleData="styleData" :isPreviewPc="2" :key="2"></UserAnswer>
					</div>
				</div>
			</div>

			<!-- 右侧盒子 -->
			<div class="wjAppearance_right">
				<div class="wjAppearance_right_children">
					<!-- 外观设置 -->
					<div class="setFirst">
						<span style="font-size: 16px; color: #333; margin-left: 10px">{{$t('Appearance.AppearanceSettings')}}</span>
						<span style="margin-right: 10px">
							<el-radio-group v-model="tabPosition" @change="tabChange">
								<el-radio-button label="phone"><i class="el-icon-mobile-phone"></i></el-radio-button>
								<el-radio-button label="computer"><i class="el-icon-monitor"></i></el-radio-button>
							</el-radio-group>
						</span>
					</div>
					<!--电话-->
					<div class="styleSet" v-if="tabPosition == 'phone'">
						<el-collapse accordion>
							<el-collapse-item class="pad">
								<template slot="title">
									{{$t('Appearance.Header')}}
								</template>

								<div class="heiSeting">
									<span class="left">{{$t('Appearance.ShowHeader')}}</span>
									<span class="right">
										<el-switch
											v-model="stylePhone.appearancePhone.headerState"
											:active-value="1"
											:inactive-value="0"
											@change="setHeaderPhone(stylePhone.appearancePhone.headerState)"
										></el-switch>
									</span>
								</div>

								<div v-if="stylePhone.appearancePhone.headerState == 1">
									<div class="heiSeting">
										<span class="left">{{$t('Appearance.HeaderType')}}</span>
										<div class="right tab_layout" style="text-indent: 0px;">
											<el-radio-group v-model="stylePhone.appearancePhone.headerType" @input="setHTPhone" size="mini">
												<el-radio-button :label="0">{{$t('Appearance.Writing')}}</el-radio-button>
												<el-radio-button :label="1">{{$t('Appearance.Single')}}</el-radio-button>
											</el-radio-group>
										</div>
									</div>
									<div v-if="stylePhone.appearancePhone.headerType == 0">
										<div class="heiSeting">
											<span class="left">{{$t('Appearance.TextContent')}}</span>
											<span class="right">
												<el-input
													v-model="stylePhone.appearancePhone.headerContent"
													:placeholder="$t('Appearance.PleaseEnterContent')"
													@blur="setHeaderContentPhone(stylePhone.appearancePhone.headerContent)"
												></el-input>
											</span>
										</div>
										<div class="heiSeting">
											<div class="aaaaa">
												<span class="left">{{$t('Appearance.FontSettings')}}</span>
												<div
													class="right"
													style="
														display: flex;
														align-items: center;
													"
												>
													<el-select 
														v-model="stylePhone.appearancePhone.titleSize" 
														filterable
														allow-create
														default-first-option
														placeholder="12" 
														@change="setTitleSizePhone" 
														size="mini"
													>
														<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
													</el-select>
													<div class="color-picker-box fontSet-item" >
														<span class="color-picker-A" :style="{'color': stylePhone.appearancePhone.headerColor}">A</span>
														<el-color-picker size="mini" v-model="stylePhone.appearancePhone.headerColor" @change="setheaderColorPhone"></el-color-picker>
													</div>
													<span 
														class="fontSet fontSet-item"
														:class="{'fontSet-active': stylePhone.appearancePhone.headerBold == 'bold'}"
													><img src="../../../public/img/cuti.png" alt="" @click="setHeaderBoldPhone" /></span>
													<span 
														class="fontSet fontSet-item"
														:class="{'fontSet-active': stylePhone.appearancePhone.headerItalic == 'italic'}"
													><img src="../../../public/img/xt.png" alt="" @click="setheaderItalicPhone" /></span>
													<span
														class="fontSet fontSet-item"
														:class="{'fontSet-active': stylePhone.appearancePhone.headerUnderline == 'underline'}"
													><img src="../../../public/img/xhx.png" alt="" @click="setheaderUnderlinePhone" /></span>
												</div>
											</div>
										</div>
										<div class="heiSeting">
											<span class="left">{{$t('Appearance.Align')}}</span>
											<div class="right tab_layout" style="text-indent: 0px;">
											<el-radio-group v-model="stylePhone.appearancePhone.headerAlign" @input="headerAlignPhone" size="mini">
												<el-radio-button label="left">{{$t('Appearance.LeftJustifying')}}</el-radio-button>
												<el-radio-button label="center">{{$t('Appearance.Center')}}</el-radio-button>
												<el-radio-button label="right">{{$t('Appearance.RightAlignment')}}</el-radio-button>
											</el-radio-group>
											</div>
										</div>
										<div class="heiSeting">
											<span class="left">{{$t('Appearance.bgColor')}}</span>
											<span class="right" style="margin-top: 10px; margin-right: 10px">
												<el-color-picker v-model="stylePhone.appearancePhone.headerBgcolor" size="mini" @change="setheaderBgcolorPhone"></el-color-picker>
											</span>
										</div>
									</div>
									<div v-if="stylePhone.appearancePhone.headerType == 1">
										<div v-if="stylePhone.appearancePhone.headerImg == ''">
											<div class="heiSeting">
												<span class="left">{{$t('Appearance.HeaderImage')}}</span>
												<span class="right">
													<el-upload
														class="avatar-uploader"
														:action="$config.service.uploadApi"
														:show-file-list="false"
														:on-success="handleSuccessPhone"
														:before-upload="beforeAvatarUpload"
														:data="QiniuData"
														:on-remove="handleRemove"
														multiple
														:limit="1"
													>
														<p style="font-size: 12px; color: #0080ff">{{$t('Appearance.AddPicture')}}</p>
													</el-upload>
												</span>
											</div>
										</div>
										<div v-if="stylePhone.appearancePhone.headerImg != ''">
											<div class="heiSeting">
												<span style="position: relative">
													<img
														:src="stylePhone.appearancePhone.headerImg"
														style="
															width: 35px;
															height: 23px;
															position: absolute;
															top: 16px;
															left: 6px;
														"
													/>
													<i class="el-icon-remove" @click="removeImgPhone" style="position: absolute; top: 17px; left: 20px"></i>
												</span>
											</div>
										</div>
									</div>
								</div>
							</el-collapse-item>
							<!-- 完成 -->
							<el-collapse-item class="pad">
								<template slot="title">
									{{$t('Appearance.Background')}}
								</template>
								<div class="heiSeting">
									<span class="left">{{$t('Appearance.BackgroundSettings')}}</span>
									<div class="right tab_layout" style="text-indent: 0px;">
										<el-radio-group v-model="stylePhone.appearancePhone.bgState" @input="setHTImgPhone" size="mini">
											<el-radio-button :label="0">{{$t('Appearance.Pictures')}}</el-radio-button>
											<el-radio-button :label="1">{{$t('Appearance.ChooseAColor')}}</el-radio-button>
										</el-radio-group>
									</div>
								</div>
								<div v-if="stylePhone.appearancePhone.bgState == 0">
									<div class="heiSeting" v-if="stylePhone.appearancePhone.bgImg == ''">
										<span class="left">{{$t('Appearance.BackgroundImage')}}</span>
										<span class="right">
											<el-upload
												class="avatar-uploader"
												:action="$config.service.uploadApi"
												:show-file-list="false"
												:on-success="handleSuccess2Phone"
												:before-upload="beforeAvatarUpload2"
												:data="QiniuData2"
												:on-remove="handleRemove2"
												multiple
												:limit="1"
											>
												<p style="font-size: 12px; color: #0080ff">{{$t('Appearance.Pictures')}}</p>
											</el-upload>
										</span>
									</div>
									<div class="heiSeting" v-if="stylePhone.appearancePhone.bgImg != ''">
										<span class="left">{{$t('Appearance.BackgroundImage')}}</span>
										<span class="right" style="position: relative">
											<img
												:src="stylePhone.appearancePhone.bgImg"
												style="
													width: 35px;
													height: 23px;
													position: absolute;
													top: 16px;
													right: 18px;
												"
											/>
											<i class="el-icon-remove" @click="removebgImgPhone" style="position: absolute; right: 5px; top: 10px"></i>
										</span>
									</div>
									<div class="heiSeting">
										<span class="left">{{$t('Appearance.BackgroundPosition')}}</span>
										<div class="right tab_layout" style="text-indent: 0px;">
											<el-radio-group v-model="stylePhone.appearancePhone.bgLocation" @input="setHTAddPhone" size="mini">
												<el-radio-button :label="0">{{$t('Appearance.Tile')}}</el-radio-button>
												<el-radio-button :label="1">{{$t('Appearance.Center')}}</el-radio-button>
											</el-radio-group>
										</div>
									</div>
									<!-- <div class="heiSeting">
										<span class="left">问卷底色</span>
										<span class="right" style="margin-top: 10px; margin-right: 10px">
											<el-color-picker v-model="stylePhone.appearancePhone.bgQuestionnaire" size="mini" @change="setbgQuestionnairePhone"></el-color-picker>
										</span>
									</div> -->
									<div class="heiSeting">
										<span class="left">{{$t('Appearance.BackgroundTransparency')}}</span>
										<div class="right block" style="width: 100px; margin-right: 20px">
											<el-slider v-model="stylePhone.appearancePhone.bgOpacity" @change="setbgOpacityPhone"></el-slider>
										</div>
									</div>
								</div>
								<div v-if="stylePhone.appearancePhone.bgState == 1">
									<div class="heiSeting">
										<span class="left">{{$t('Appearance.bgColor')}}</span>
										<span class="right" style="margin-top: 10px; margin-right: 10px">
											<el-color-picker v-model="stylePhone.appearancePhone.bgColor" size="mini" @change="setbgColorPhone"></el-color-picker>
										</span>
									</div>
									<!-- <div class="heiSeting">
										<span class="left">问卷底色</span>
										<span class="right" style="margin-top: 10px; margin-right: 10px">
											<el-color-picker v-model="stylePhone.appearancePhone.bgQuestionnaire" size="mini" @change="setbgQuestionnairePhone"></el-color-picker>
										</span>
									</div> -->

									<div class="heiSeting">
										<span class="left">{{$t('Appearance.BackgroundTransparency')}}</span>
										<div class="right block" style="width: 100px; margin-right: -32px">
											<el-slider v-model="stylePhone.appearancePhone.bgOpacity" @change="setbgOpacityPhone"></el-slider>
										</div>
									</div>
								</div>
							</el-collapse-item>
							<!-- 完成 -->
							<el-collapse-item class="pad">
								<template slot="title">
									logo
								</template>
								<div class="heiSeting" v-if="stylePhone.appearancePhone.logoSet == ''">
									<span class="left">{{$t('Appearance.LogoSettings')}}</span>
									<span class="right">
										<el-upload
											class="avatar-uploader"
											:action="$config.service.uploadApi"
											:show-file-list="false"
											:on-success="handleSuccess3Phone"
											:before-upload="beforeAvatarUpload3"
											:data="QiniuData3"
											:on-remove="handleRemove3"
											multiple
											:limit="1"
										>
											<p style="font-size: 12px; color: #0080ff">{{$t('Appearance.Pictures')}}</p>
										</el-upload>
									</span>
								</div>
								<div class="heiSeting" v-if="stylePhone.appearancePhone.logoSet != ''">
									<span class="left">{{$t('Appearance.LogoSettings')}}</span>
									<span class="right" style="position: relative">
										<img
											:src="stylePhone.appearancePhone.logoSet"
											style="
												width: 35px;
												height: 23px;
												position: absolute;
												top: 16px;
												right: 18px;
											"
										/>
										<i class="el-icon-remove" @click="removelogoSetPhone" style="position: absolute; right: 5px; top: 10px"></i>
									</span>
								</div>
								<div class="heiSeting">
									<span class="left">{{$t('Appearance.LogoLocation')}}</span>
									<div class="right tab_layout" style="text-indent: 0px;">
										<el-radio-group v-model="stylePhone.appearancePhone.logoLocation" @input="setHTlogoLocationPhone" size="mini">
											<el-radio-button label="left">{{$t('Appearance.LeftJustifying')}}</el-radio-button>
											<el-radio-button label="center">{{$t('Appearance.Center')}}</el-radio-button>
											<el-radio-button label="right">{{$t('Appearance.RightAlignment')}}</el-radio-button>
										</el-radio-group>
									</div>
								</div>
							</el-collapse-item>

							<el-collapse-item class="pad">
								<template slot="title">
									{{$t('Appearance.FontSettings')}}
								</template>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">{{$t('Appearance.ProjectTitle')}}</span>
										<div
											class="right"
											style="
												display: flex;
												align-items: center;
											"
										>
											<el-select
												filterable
												allow-create
												default-first-option 
												v-model="stylePhone.appearancePhone.fontTitleSize" 
												placeholder="12" 
												@change="setfontTitleSize"
												size="mini"
											>
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<div class="color-picker-box fontSet-item">
												<span class="color-picker-A" :style="{'color': stylePhone.appearancePhone.fontTitleColor}">A</span>
												<el-color-picker size="mini" v-model="stylePhone.appearancePhone.fontTitleColor" @change="setfontTitleColorPhone"></el-color-picker>
											</div>
											<span 
												class="fontSet fontSet-item"
												:class="{'fontSet-active': stylePhone.appearancePhone.fontTitleBold == 'bold'}"
											><img src="../../../public/img/cuti.png" alt="" @click="setfontTitleBoldPhone" /></span>
											<span 
												class="fontSet fontSet-item"
												:class="{'fontSet-active': stylePhone.appearancePhone.fontTitleItalic == 'italic'}"
												
											><img src="../../../public/img/xt.png" alt="" @click="setfontTitleItalicPhone" /></span>
											<span
												class="fontSet fontSet-item"
												:class="{'fontSet-active': stylePhone.appearancePhone.fontTitleUnderline == 'underline'}"
											><img src="../../../public/img/xhx.png" alt="" @click="setfontTitleUnderlinePhone" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">{{$t('Appearance.WelcomeMessage')}}</span>
										<div
											class="right"
											style="
												display: flex;
												align-items: center;
											"
										>
											<el-select 
												filterable
												allow-create
												default-first-option 
												v-model="stylePhone.appearancePhone.fontWelcomeSize" 
												placeholder="12" 
												@change="setfontWelcomeSizePhone" 
												size="mini"
											>
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<div class="color-picker-box fontSet-item">
												<span class="color-picker-A" :style="{'color': style.appearance.fontWelcomeColor}">A</span>
												<el-color-picker size="mini" v-model="style.appearance.fontWelcomeColor" @change="setfontWelcomeColorPhone"></el-color-picker>
											</div>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': stylePhone.appearancePhone.fontWelcomeBold == 'bold'}"><img src="../../../public/img/cuti.png" alt="" @click="setfontWelcomeBoldPhone" /></span>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': stylePhone.appearancePhone.fontWelcomeItalic == 'italic'}"><img src="../../../public/img/xt.png" alt="" @click="setfontWelcomeItalicPhone" /></span>
											<span
												class="fontSet fontSet-item"
												:class="{'fontSet-active': stylePhone.appearancePhone.fontWelcomeUnderline == 'underline'}"
											><img src="../../../public/img/xhx.png" alt="" @click="setfontWelcomeUnderlinePhone" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">{{$t('Appearance.Stem')}}</span>
										<div
											class="right"
											style="
												display: flex;
												align-items: center;
											"
										>
											<el-select 
												filterable
												allow-create
												default-first-option 
												v-model="stylePhone.appearancePhone.fontStemSize" 
												placeholder="12" 
												@change="setfontStemSizePhone" 
												size="mini"
											>
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<div class="color-picker-box fontSet-item">
												<span class="color-picker-A" :style="{'color': stylePhone.appearancePhone.fontStemColor}">A</span>
												<el-color-picker size="mini" v-model="stylePhone.appearancePhone.fontStemColor" @change="setfontStemColorPhone"></el-color-picker>
											</div>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': stylePhone.appearancePhone.fontStemBold == 'bold'}"><img src="../../../public/img/cuti.png" alt="" @click="setfontStemBoldPhone" /></span>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': stylePhone.appearancePhone.fontStemItalic == 'italic'}"><img src="../../../public/img/xt.png" alt="" @click="setfontStemItalicPhone" /></span>
											<span
												class="fontSet fontSet-item"
												:class="{'fontSet-active': stylePhone.appearancePhone.fontStemUnderline == 'underline'}"
											><img src="../../../public/img/xhx.png" alt="" @click="setfontStemUnderlinePhone" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">{{$t('Appearance.Option')}}</span>
										<div
											class="right"
											style="
												display: flex;
												align-items: center;
											"
										>
											<el-select
												filterable
												allow-create
												default-first-option  
												v-model="stylePhone.appearancePhone.fontOptionSize" 
												placeholder="12" 
												@change="setfontOptionSizePhone" 
												size="mini"
											>
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<div class="color-picker-box fontSet-item">
												<span class="color-picker-A" :style="{'color': stylePhone.appearancePhone.fontOptionColor}">A</span>
												<el-color-picker size="mini" v-model="stylePhone.appearancePhone.fontOptionColor" @change="setfontOptionColorPhone"></el-color-picker>
											</div>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': stylePhone.appearancePhone.fontOptionBold == 'bold'}"><img src="../../../public/img/cuti.png" alt="" @click="setfontOptionBoldPhone" /></span>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': stylePhone.appearancePhone.fontOptionItalic == 'italic'}"><img src="../../../public/img/xt.png" alt="" @click="setfontOptionItalicPhone" /></span>
											<span
												class="fontSet fontSet-item"
												:class="{'fontSet-active': stylePhone.appearancePhone.fontOptionUnderline == 'underline'}"
											><img src="../../../public/img/xhx.png" alt="" @click="setfontOptionUnderlinePhone" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">{{$t('Appearance.Conclusion')}}</span>
										<div
											class="right"
											style="
												display: flex;
												align-items: center;
											"
										>
											<el-select 
												filterable
												allow-create
												default-first-option 
												v-model="style.appearance.titleSize" 
												placeholder="12" 
												@change="setTitleSizePhone" 
												size="mini"
											>
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<div class="color-picker-box fontSet-item">
												<span class="color-picker-A" :style="{'color': style.appearance.headerColor}">A</span>
												<el-color-picker size="mini" v-model="style.appearance.headerColor" @change="setheaderColor"></el-color-picker>
											</div>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.headerBold == 'bold'}"><img src="../../../public/img/cuti.png" alt="" @click="setHeaderBold" /></span>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.headerItalic == 'italic'}"><img src="../../../public/img/xt.png" alt="" @click="setheaderItalic" /></span>
											<span
												class="fontSet fontSet-item"
												:class="{'fontSet-active': style.appearance.headerUnderline == 'underline'}"
											><img src="../../../public/img/xhx.png" alt="" @click="setheaderUnderline" /></span>
										</div>
									</div>
								</div>
							</el-collapse-item>
							<!-- 完成 -->
							<el-collapse-item class="pad">
								<template slot="title">
									{{$t('Appearance.ButtonSettings')}}
								</template>
								<div class="heiSeting">
									<span class="left">{{$t('Appearance.SubmitButtonText')}}</span>
									<span class="right">
										<el-input
											v-model="stylePhone.appearancePhone.buttonContent"
											:placeholder="$t('Appearance.PleaseEnterContent')"
											@blur="btnTextPhone(stylePhone.appearancePhone.buttonContent)"
										></el-input>
									</span>
								</div>
							</el-collapse-item>
							<!-- 完成 -->
							<el-collapse-item class="pad">
								<template slot="title">
									{{$t('Appearance.DisplaySettings')}}
								</template>
								<div class="heiSeting">
									<span class="left">{{$t('Appearance.ShowHeading')}}</span>
									<span class="right">
										<el-switch
											v-model="stylePhone.appearancePhone.displayTitle"
											:active-value="1"
											:inactive-value="0"
											@change="distitlePhone(stylePhone.appearancePhone.displayTitle)"
										></el-switch>
									</span>
								</div>
								<div class="heiSeting">
									<span class="left">{{$t('Appearance.ShowWelcomeMessage')}}</span>
									<span class="right">
										<el-switch
											v-model="stylePhone.appearancePhone.displayWelcome"
											:active-value="1"
											:inactive-value="0"
											@change="diswelPhone(stylePhone.appearancePhone.displayWelcome)"
										></el-switch>
									</span>
								</div>
								<div class="heiSeting">
									<span class="left">{{$t('Appearance.DisplayQuestionNumber')}}</span>
									<span class="right">
										<el-switch
											v-model="stylePhone.appearancePhone.displayQuestionsno"
											:active-value="1"
											:inactive-value="0"
											@change="disQuestPhone(stylePhone.appearancePhone.displayQuestionsno)"
										></el-switch>
									</span>
								</div>
							</el-collapse-item>
						</el-collapse>
					</div>

					<!--电脑-->
					<div class="styleSet" v-if="tabPosition == 'computer'">
						<el-collapse accordion>
							<!-- 完成 -->
							<el-collapse-item class="pad">
								<template slot="title">
									{{ $t('Appearance.Header') }}
								</template>
								<div class="heiSeting">
									<span class="left">{{$t('Appearance.ShowHeader')}}</span>
									<span class="right">
										<el-switch
											v-model="style.appearance.headerState"
											:active-value="1"
											:inactive-value="0"
											@change="setHeader(style.appearance.headerState)"
										></el-switch>
									</span>
								</div>
								<div v-if="style.appearance.headerState == 1">
									<div class="heiSeting">
										<span class="left">{{$t('Appearance.HeaderType')}}</span>
										<div class="right tab_layout" style="text-indent: 0px;">
											<el-radio-group v-model="style.appearance.headerType" @input="setHT" size="mini">
												<el-radio-button :label="0">{{$t('Appearance.Writing')}}</el-radio-button>
												<el-radio-button :label="1">{{$t('Appearance.Single')}}</el-radio-button>
											</el-radio-group>
										</div>
									</div>
									<div v-if="style.appearance.headerType == 0">
										<div class="heiSeting">
											<span class="left">{{$t('Appearance.TextContent')}}</span>
											<span class="right">
												<el-input
													v-model="style.appearance.headerContent"
													:placeholder="$t('Appearance.PleaseEnterContent')"
													@blur="setHeaderContent(style.appearance.headerContent)"
												></el-input>
											</span>
										</div>
										<div class="heiSeting">
											<div class="aaaaa">
												<span class="left">{{$t('Appearance.FontSettings')}}</span>
												<div
													class="right"
													style="
														display: flex;
														align-items: center;
													"
												>
													<!--页眉里的字体设置-->
													<el-select
														filterable
														allow-create
														default-first-option 
														v-model="style.appearance.titleSize" 
														placeholder="12" 
														@change="setTitleSize" 
														size="mini"
													>
														<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
													</el-select>
													<div class="color-picker-box fontSet-item">
														<span class="color-picker-A" :style="{'color': style.appearance.headerColor}">A</span>
														<el-color-picker size="mini" v-model="style.appearance.headerColor" @change="setheaderColor"></el-color-picker>
													</div>
													<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.headerBold == 'bold'}"><img src="../../../public/img/cuti.png" alt="" @click="setHeaderBold" /></span>
													<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.headerItalic == 'italic'}"><img src="../../../public/img/xt.png" alt="" @click="setheaderItalic" /></span>
													<span
														class="fontSet fontSet-item"
														:class="{'fontSet-active': style.appearance.headerUnderline == 'underline'}"
													><img src="../../../public/img/xhx.png" alt="" @click="setheaderUnderline" /></span>
												</div>
											</div>
										</div>
										<div class="heiSeting">
											<span class="left">{{$t('Appearance.Align')}}</span>
											<div class="right tab_layout" style="text-indent: 0px;">
												<el-radio-group v-model="style.appearance.headerAlign" @input="headerAlign" size="mini">
													<el-radio-button label="left">{{$t('Appearance.LeftJustifying')}}</el-radio-button>
													<el-radio-button label="center">{{$t('Appearance.Center')}}</el-radio-button>
													<el-radio-button label="right">{{$t('Appearance.RightAlignment')}}</el-radio-button>
												</el-radio-group>
											</div>
										</div>
										<div class="heiSeting">
											<span class="left">{{$t('Appearance.bgColor')}}</span>
											<span class="right" style="margin-top: 10px; margin-right: 10px">
												<el-color-picker v-model="style.appearance.headerBgcolor" size="mini" @change="setheaderBgcolor"></el-color-picker>
											</span>
										</div>
									</div>
									<div v-if="style.appearance.headerType == 1">
										<div v-if="style.appearance.headerImg == ''">
											<div class="heiSeting">
												<span class="left">{{$t('Appearance.HeaderImage')}}</span>
												<span class="right">
													<el-upload
														class="avatar-uploader"
														:action="$config.service.uploadApi"
														:show-file-list="false"
														:on-success="handleSuccess"
														:before-upload="beforeAvatarUpload"
														:data="QiniuData"
														:on-remove="handleRemove"
														multiple
														:limit="1"
													>
														<p style="font-size: 12px; color: #0080ff">{{$t('Appearance.AddPicture')}}</p>
													</el-upload>
												</span>
											</div>
										</div>
										<!--页眉单图图片显示区 -->
										<div v-if="style.appearance.headerImg != ''">
											<div class="heiSeting">
												<span style="position: relative">
													<img
														:src="style.appearance.headerImg"
														style="
															width: 35px;
															height: 35px;
															position: absolute;
															top: 9px;
															left: 6px;
														"
													/>
													<i class="el-icon-remove" @click="removeImg" style="position: absolute; top: 1px; left: 20px"></i>
												</span>
											</div>
										</div>
									</div>
								</div>
							</el-collapse-item>
							<!-- 完成  电脑-->
							<el-collapse-item class="pad">
								<template slot="title">
									{{$t('Appearance.Background')}}
								</template>
								<div class="heiSeting">
									<span class="left">{{$t('Appearance.BackgroundSettings')}}</span>
									<div class="right tab_layout" style="text-indent: 0px;">
										<el-radio-group v-model="style.appearance.bgState" @input="setHTImg" size="mini">
											<el-radio-button :label="0">{{$t('Appearance.Pictures')}}</el-radio-button>
											<el-radio-button :label="1">{{$t('Appearance.ChooseAColor')}}</el-radio-button>
										</el-radio-group>
									</div>
								</div>
								<div v-if="style.appearance.bgState == 0">
									<div class="heiSeting" v-if="style.appearance.bgImg == ''">
										<span class="left">{{$t('Appearance.BackgroundImage')}}</span>
										<span class="right">
											<!-- 电脑上传背景图片 -->
											<el-upload
												class="avatar-uploader"
												:action="$config.service.uploadApi"
												:show-file-list="false"
												:on-success="handleSuccess2"
												:before-upload="beforeAvatarUpload2"
												:data="QiniuData2"
												:on-remove="handleRemove2"
												multiple
												:limit="1"
											>
												<p style="font-size: 12px; color: #0080ff">{{$t('Appearance.Pictures')}}</p>
											</el-upload>
										</span>
									</div>
									<div class="heiSeting" v-if="style.appearance.bgImg != ''">
										<span class="left">{{$t('Appearance.BackgroundImage')}}</span>
										<span class="right" style="position: relative">
											<img
												:src="style.appearance.bgImg"
												style="
													width: 35px;
													height: 23px;
													position: absolute;
													top: 16px;
													right: 18px;
												"
											/>
											<i class="el-icon-remove" @click="removebgImg" style="position: absolute; right: 5px; top: 10px"></i>
										</span>
									</div>
									<div class="heiSeting">
										<span class="left">{{$t('Appearance.BackgroundPosition')}}</span>
										<div class="right tab_layout" style="text-indent: 0px;">
											<el-radio-group v-model="style.appearance.bgLocation" @input="setHTAdd" size="mini">
												<el-radio-button :label="0">{{$t('Appearance.Tile')}}</el-radio-button>
												<el-radio-button :label="1">{{$t('Appearance.Center')}}</el-radio-button>
											</el-radio-group>
										</div>
									</div>
									<!-- <div class="heiSeting">
										<span class="left">问卷底色</span>
										<span class="right" style="margin-top: 10px; margin-right: 10px">
											<el-color-picker v-model="style.appearance.bgQuestionnaire" size="mini" @change="setbgQuestionnaire"></el-color-picker>
										</span>
									</div> -->
									<div class="heiSeting">
										<span class="left">{{$t('Appearance.BackgroundTransparency')}}</span>
										<div class="right block" style="width: 100px; margin-right: 20px">
											<el-slider v-model="style.appearance.bgOpacity" @change="setbgOpacity"></el-slider>
										</div>
									</div>
								</div>
								<div v-if="style.appearance.bgState == 1">
									<div class="heiSeting">
										<span class="left">{{$t('Appearance.bgColor')}}</span>
										<span class="right" style="margin-top: 10px; margin-right: 10px">
											<el-color-picker v-model="style.appearance.bgColor" size="mini" @change="setbgColor"></el-color-picker>
										</span>
									</div>
									<!-- <div class="heiSeting">
										<span class="left">问卷底色</span>
										<span class="right" style="margin-top: 10px; margin-right: 10px">
											<el-color-picker v-model="style.appearance.bgQuestionnaire" size="mini" @change="setbgQuestionnaire"></el-color-picker>
										</span>
									</div> -->
									<div class="heiSeting">
										<span class="left">{{$t('Appearance.BackgroundTransparency')}}</span>
										<div class="right block" style="width: 100px; margin-right:-32px">
											<el-slider v-model="style.appearance.bgOpacity" @change="setbgOpacity"></el-slider>
										</div>
									</div>
								</div>
							</el-collapse-item>
							<!-- 完成 -->
							<el-collapse-item class="pad">
								<template slot="title">
									logo
								</template>
								<div class="heiSeting" v-if="style.appearance.logoSet == ''">
									<span class="left">{{$t('Appearance.LogoSettings')}}</span>
									<span class="right">
										<el-upload
											class="avatar-uploader"
											:action="$config.service.uploadApi"
											:show-file-list="false"
											:on-success="handleSuccess3"
											:before-upload="beforeAvatarUpload3"
											:data="QiniuData3"
											:on-remove="handleRemove3"
											multiple
											:limit="1"
										>
											<p style="font-size: 12px; color: #0080ff">{{$t('Appearance.Pictures')}}</p>
										</el-upload>
									</span>
								</div>
								<div class="heiSeting" v-if="style.appearance.logoSet != ''">
									<span class="left">{{$t('Appearance.LogoSettings')}}</span>
									<span class="right" style="position: relative">
										<!-- logo设置 -->
										<img
											:src="style.appearance.logoSet"
											style="
												width: 35px;
												height: 23px;
												position: absolute;
												top: 16px;
												right: 18px;
											"
										/>
										<i class="el-icon-remove" @click="removelogoSet" style="position: absolute; right: 5px; top: 10px"></i>
									</span>
								</div>
								<div class="heiSeting">
									<span class="left">{{$t('Appearance.LogoLocation')}}</span>
									<div class="right tab_layout" style="text-indent: 0px;">
										<el-radio-group v-model="style.appearance.logoLocation" @input="setHTlogoLocation" size="mini">
											<el-radio-button label="left">{{$t('Appearance.LeftJustifying')}}</el-radio-button>
											<el-radio-button label="center">{{$t('Appearance.Center')}}</el-radio-button>
											<el-radio-button label="right">{{$t('Appearance.RightAlignment')}}</el-radio-button>
										</el-radio-group>
									</div>
								</div>
							</el-collapse-item>

							<el-collapse-item class="pad">
								<template slot="title">
									{{$t('Appearance.FontSettings')}}
								</template>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">{{$t('Appearance.ProjectTitle')}}</span>
										<div
											class="right"
											style="
												display: flex;
												align-items: center;
											"
										>
											<el-select 
												v-model="style.appearance.fontTitleSize" 
												filterable
												allow-create
												default-first-option
												placeholder="12" 
												@change="setfontTitleSize" 
												size="mini"
											>
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<div class="color-picker-box fontSet-item">
												<span class="color-picker-A" :style="{'color': style.appearance.fontTitleColor}">A</span>
												<el-color-picker size="mini" v-model="style.appearance.fontTitleColor" @change="setfontTitleColor"></el-color-picker>
											</div>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.fontTitleBold == 'bold'}"><img src="../../../public/img/cuti.png" alt="" @click="setfontTitleBold" /></span>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.fontTitleItalic == 'italic'}"><img src="../../../public/img/xt.png" alt="" @click="setfontTitleItalic" /></span>
											<span
												class="fontSet fontSet-item"
												:class="{'fontSet-active': style.appearance.fontTitleUnderline == 'underline'}"
											><img src="../../../public/img/xhx.png" alt="" @click="setfontTitleUnderline" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">{{$t('Appearance.WelcomeMessage')}}</span>
										<div
											class="right"
											style="
												display: flex;
												align-items: center;
											"
										>
											<el-select
												filterable
												allow-create
												default-first-option 
												v-model="style.appearance.fontWelcomeSize" 
												placeholder="12" 
												@change="setfontWelcomeSize" 
												size="mini"
											>
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<div class="color-picker-box fontSet-item">
												<span class="color-picker-A" :style="{'color': style.appearance.fontWelcomeColor}">A</span>
												<el-color-picker size="mini" v-model="style.appearance.fontWelcomeColor" @change="setfontWelcomeColor"></el-color-picker>
											</div>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.fontWelcomeBold == 'bold'}"><img src="../../../public/img/cuti.png" alt="" @click="setfontWelcomeBold" /></span>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.fontWelcomeItalic == 'italic'}"><img src="../../../public/img/xt.png" alt="" @click="setfontWelcomeItalic" /></span>
											<span
												class="fontSet fontSet-item"
												:class="{'fontSet-active': style.appearance.fontWelcomeUnderline == 'underline'}"
											><img src="../../../public/img/xhx.png" alt="" @click="setfontWelcomeUnderline" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">{{$t('Appearance.Stem')}}</span>
										<div
											class="right"
											style="
												display: flex;
												align-items: center;
											"
										>
											<el-select
												filterable
												allow-create
												default-first-option  
												v-model="style.appearance.fontStemSize" 
												placeholder="12" 
												@change="setfontStemSize" 
												size="mini"
											>
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<div class="color-picker-box fontSet-item">
												<span class="color-picker-A" :style="{'color': style.appearance.fontStemColor}">A</span>
												<el-color-picker size="mini" v-model="style.appearance.fontStemColor" @change="setfontStemColor"></el-color-picker>
											</div>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.fontStemBold == 'bold'}"><img src="../../../public/img/cuti.png" alt="" @click="setfontStemBold" /></span>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.fontStemItalic == 'italic'}"><img src="../../../public/img/xt.png" alt="" @click="setfontStemItalic" /></span>
											<span
												class="fontSet fontSet-item"
												:class="{'fontSet-active': style.appearance.fontStemUnderline == 'underline'}"
											><img src="../../../public/img/xhx.png" alt="" @click="setfontStemUnderline" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">{{$t('Appearance.Option')}}</span>
										<div
											class="right"
											style="
												display: flex;
												align-items: center;
											"
										>
											<el-select
												filterable
												allow-create
												default-first-option 
												v-model="style.appearance.fontOptionSize" 
												placeholder="12" 
												@change="setfontOptionSize" 
												size="mini"
											>
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<div class="color-picker-box fontSet-item">
												<span class="color-picker-A" :style="{'color': style.appearance.fontOptionColor}">A</span>
												<el-color-picker size="mini" v-model="style.appearance.fontOptionColor" @change="setfontOptionColor"></el-color-picker>
											</div>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.fontOptionBold == 'bold'}"><img src="../../../public/img/cuti.png" alt="" @click="setfontOptionBold" /></span>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.fontOptionItalic == 'italic'}"><img src="../../../public/img/xt.png" alt="" @click="setfontOptionItalic" /></span>
											<span
												class="fontSet fontSet-item"
												:class="{'fontSet-active': style.appearance.fontOptionUnderline == 'underline'}"
											><img src="../../../public/img/xhx.png" alt="" @click="setfontOptionUnderline" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">{{$t('Appearance.Conclusion')}}</span>
										<div
											class="right"
											style="
												display: flex;
												align-items: center;
											"
										>
											<el-select
												filterable
												allow-create
												default-first-option  
												v-model="style.appearance.fontEndSize" 
												placeholder="12" 
												@change="setfontEndSize" 
												size="mini"
											>
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<div class="color-picker-box">
												<span class="color-picker-A" :style="{'color': style.appearance.fontEndColor}">A</span>
												<el-color-picker  size="mini" v-model="style.appearance.fontEndColor" @change="setfontEndColor"></el-color-picker>
											</div>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.fontEndBold == 'bold'}"><img src="../../../public/img/cuti.png" alt="" @click="setfontEndBold" /></span>
											<span class="fontSet fontSet-item" :class="{'fontSet-active': style.appearance.fontEndItalic == 'italic'}"><img src="../../../public/img/xt.png" alt="" @click="setfontEndItalic" /></span>
											<span
												class="fontSet fontSet-item"
												:class="{'fontSet-active': style.appearance.fontEndUnderline == 'underline'}"
											><img src="../../../public/img/xhx.png" alt="" @click="setfontEndUnderline" /></span>
										</div>
									</div>
								</div>
							</el-collapse-item>
							<!-- 完成 -->
							<el-collapse-item class="pad">
								<template slot="title">
									{{$t('Appearance.ButtonSettings')}}
								</template>
								<div class="heiSeting">
									<span class="left">{{$t('Appearance.SubmitButtonText')}}</span>
									<span class="right">
										<el-input v-model="style.appearance.buttonContent" :placeholder="$t('Appearance.PleaseEnterContent')" @blur="btnText(style.appearance.buttonContent)"></el-input>
									</span>
								</div>
							</el-collapse-item>
							<!-- 完成 -->
							<el-collapse-item class="pad">
								<template slot="title">
									{{$t('Appearance.DisplaySettings')}}
								</template>
								<div class="heiSeting">
									<span class="left">{{$t('Appearance.ShowHeading')}}</span>
									<span class="right">
										<el-switch
											v-model="style.appearance.displayTitle"
											:active-value="1"
											:inactive-value="0"
											@change="distitle(style.appearance.displayTitle)"
										></el-switch>
									</span>
								</div>
								<div class="heiSeting">
									<span class="left">{{$t('Appearance.ShowWelcomeMessage')}}</span>
									<span class="right">
										<el-switch
											v-model="style.appearance.displayWelcome"
											:active-value="1"
											:inactive-value="0"
											@change="diswel(style.appearance.displayWelcome)"
										></el-switch>
									</span>
								</div>
								<div class="heiSeting">
									<span class="left">{{$t('Appearance.DisplayQuestionNumber')}}</span>
									<span class="right">
										<el-switch
											v-model="style.appearance.displayQuestionsno"
											:active-value="1"
											:inactive-value="0"
											@change="disQuest(style.appearance.displayQuestionsno)"
										></el-switch>
									</span>
								</div>
							</el-collapse-item>
						</el-collapse>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import UserAnswer from './userAnswer.vue'
import { mapState } from "vuex";
export default {
	name: 'Appearance',
    components:{
        UserAnswer
    },
	data() {
		return {
			bgindex: 0,
			childIndex: 0,
			yanse: '',
			paperappurl: '',
			paperpcurl: '',
			tabPosition: 'phone',
			resultBody: [],
			activeName: '1',
			style: {
				subjectColor: '',
				appearance: {
					headerBgcolor: '#EFF4FE',
					bgLocation: 0
				}
			},
			stylePhone: {
				subjectColor: '',
				appearancePhone: {
					buttonContent: this.$t('Appearance.SubmitTo'),
					submitButtonColor: '',
					logoSet: '', //logo
					headerImg: '', //页眉图片
					headerState: '', //页眉设置
					headerType: 0, //头部 文字图片切换
					headerContent: '', //头部内容
					titleSize: '', //标题大小
					headerColor: '', // 头部颜色
					headerBold: '', //头部加粗
					bgState: 0, //背景图片文字切换
					bgImg: '', //背景图片
					bgQuestionnaire: '', //问卷底色
					bgOpacity: 100, //背景透明度
					headerBgcolor: '#EFF4FE', //背景颜色
					bgColor: '#FFFFFF', //背景颜色
					fontTitleSize: '',
					// 项目
					fontTitleBold: '',
					fontTitleColor: '',
					fontTitleItalic: '',
					fontTitleSize: '',
					fontTitleUnderline: '',
					bgLocation: 0
				}
			},
			pageUrl: '',
			headerType: 0,
			options: [{ val: 14 }, { val: 16 }, { val: 18 }, { val: 20 }, { val: 22 }, { val: 28 }, { val: 36 }, { val: 48 }],
			QiniuData: {
				biz: 'upDataWj',
				data: {}
			},
			QiniuData2: {
				biz: 'upDataWj',
				data: {}
			},
			QiniuData3: {
				biz: 'upDataWj',
				data: {}
			},
			uploadPicUrl: '',
			fileList: [],
			styleData: {
				appearance: {},
				appearancePhone: {},
				subjectColor: ''
			}
		};
	},
  	computed:{
		...mapState(['headers']),
	},
	mounted() {
		let that = this;
		let bgindex = localStorage.getItem('bgindex');
		// that.loadAskTypeData()
		var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
		this.height = winHeight - 108;
		this.rightheight = winHeight - 60;
		window.onresize = () => {
			var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
			this.height = winHeight - 108;
			this.rightheight = winHeight - 60;
		};

		//在mounted钩子函数绑定滚动条事件
		// document.getElementById("wenjuan_list").addEventListener('scroll', this.scroll);
		this.wid = sessionStorage.getItem('wid') || 0;
		// console.log('输出id', that.wid);
		if (this.wid == 0) {
			// this.wjadd();
		} else {
			sessionStorage.setItem('wid', this.wid);
		}
		this.loadAppear();
		this.loadStyle();
	},
	created() {
	},
	watch:{
		'style': {
			handler(vnew, vold) {
				this.styleData.appearance = vnew.appearance
				this.styleData.subjectColor = vnew.subjectColor
			},
			deep: true,
			immediate: true
		},
		'stylePhone': {
			handler(vnew, vold) {
				this.styleData.appearancePhone = vnew.appearancePhone
				this.styleData.subjectColor = vnew.subjectColor
			},
			deep: true,
			immediate: true
		},
		'styleData': {
			handler(vnew, vold) {
                // console.log('asdsadsad')
				// console.log(vnew)
				// this.style.appearance = vnew.appearance; //pc 外观
                // this.stylePhone.appearancePhone = vnew.appearancePhone; //手机外观
                // this.style.subjectColor = vnew.subjectColor;
                // this.stylePhone.subjectColor = vnew.subjectColor;
			},
			deep: true,
		},
	},
	methods: {
		//结束语 下划线       ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓
		setfontEndUnderline() {
			if (this.style.appearance.fontEndUnderline == '') {
				this.style.appearance.fontEndUnderline = 'underline';
			} else if (this.style.appearance.fontEndUnderline == 'underline') {
				this.style.appearance.fontEndUnderline = '';
			}
			this.sendmessage();
		},
		//结束语  斜体
		setfontEndItalic() {
			if (this.style.appearance.fontEndItalic == '') {
				this.style.appearance.fontEndItalic = 'italic';
			} else if (this.style.appearance.fontEndItalic == 'italic') {
				this.style.appearance.fontEndItalic = '';
			}
			this.sendmessage();
		},
		//结束语  加粗
		setfontEndBold() {
			if (this.style.appearance.fontEndBold == '') {
				this.style.appearance.fontEndBold = 'bold';
			} else if (this.style.appearance.fontEndBold == 'bold') {
				this.style.appearance.fontEndBold = '';
			}
			this.sendmessage();
		},
		//结束语 字体颜色
		setfontEndColor(val) {
			this.style.appearance.fontEndColor = val;
			this.sendmessage();
		},
		//字体设置 结束语
		setfontEndSize(item) {
			// console.log('itme项目选项', item);
			this.style.appearance.fontEndSize = item;
			this.sendmessage();
		},
		//选项 字体下划线
		setfontOptionUnderline() {
			if (this.style.appearance.fontOptionUnderline == '') {
				this.style.appearance.fontOptionUnderline = 'underline';
			} else if (this.style.appearance.fontOptionUnderline == 'underline') {
				this.style.appearance.fontOptionUnderline = '';
			}
			this.sendmessage();
		},
		setfontOptionUnderlinePhone() {
			if (this.stylePhone.appearancePhone.fontOptionUnderline == '') {
				this.stylePhone.appearancePhone.fontOptionUnderline = 'underline';
			} else if (this.stylePhone.appearancePhone.fontOptionUnderline == 'underline') {
				this.stylePhone.appearancePhone.fontOptionUnderline = '';
			}
			this.sendmessage();
		},
		//选项 字体斜体
		setfontOptionItalic() {
			if (this.style.appearance.fontOptionItalic == '') {
				this.style.appearance.fontOptionItalic = 'italic';
			} else if (this.style.appearance.fontOptionItalic == 'italic') {
				this.style.appearance.fontOptionItalic = '';
			}
			this.sendmessage();
		},
		setfontOptionItalicPhone() {
			if (this.stylePhone.appearancePhone.fontOptionItalic == '') {
				this.stylePhone.appearancePhone.fontOptionItalic = 'italic';
			} else if (this.stylePhone.appearancePhone.fontOptionItalic == 'italic') {
				this.stylePhone.appearancePhone.fontOptionItalic = '';
			}
			this.sendmessage();
		},
		//选项 字体加粗
		setfontOptionBold() {
			if (this.style.appearance.fontOptionBold == '') {
				this.style.appearance.fontOptionBold = 'bold';
			} else if (this.style.appearance.fontOptionBold == 'bold') {
				this.style.appearance.fontOptionBold = '';
			}
			this.sendmessage();
		},
		setfontOptionBoldPhone() {
			if (this.stylePhone.appearancePhone.fontOptionBold == '') {
				this.stylePhone.appearancePhone.fontOptionBold = 'bold';
			} else if (this.stylePhone.appearancePhone.fontOptionBold == 'bold') {
				this.stylePhone.appearancePhone.fontOptionBold = '';
			}
			this.sendmessage();
		},
		//选项 字体颜色
		setfontOptionColor(val) {
			this.style.appearance.fontOptionColor = val;
			this.sendmessage();
		},
		setfontOptionColorPhone(val) {
			this.stylePhone.appearancePhone.fontOptionColor = val;
			this.sendmessage();
		},
		//字体设置 选项
		setfontOptionSize(item) {
			// console.log('itme项目选项', item);
			this.style.appearance.fontOptionSize = item;
			this.sendmessage();
		},
		setfontOptionSizePhone(item) {
			// console.log('itme项目选项', item);
			this.stylePhone.appearancePhone.fontOptionSize = item;
			this.sendmessage();
		},
		//设置字体下划线
		setfontStemUnderline() {
			if (this.style.appearance.fontStemUnderline == '') {
				this.style.appearance.fontStemUnderline = 'underline';
			} else if (this.style.appearance.fontStemUnderline == 'underline') {
				this.style.appearance.fontStemUnderline = '';
			}
			this.sendmessage();
		},
		setfontStemUnderlinePhone() {
			if (this.stylePhone.appearancePhone.fontStemUnderline == '') {
				this.stylePhone.appearancePhone.fontStemUnderline = 'underline';
			} else if (this.stylePhone.appearancePhone.fontStemUnderline == 'underline') {
				this.stylePhone.appearancePhone.fontStemUnderline = '';
			}
			this.sendmessage();
		},
		//题干 斜线
		setfontStemItalic() {
			if (this.style.appearance.fontStemItalic == '') {
				this.style.appearance.fontStemItalic = 'italic';
			} else if (this.style.appearance.fontStemItalic == 'italic') {
				this.style.appearance.fontStemItalic = '';
			}
			this.sendmessage();
		},
		setfontStemItalicPhone() {
			if (this.stylePhone.appearancePhone.fontStemItalic == '') {
				this.stylePhone.appearancePhone.fontStemItalic = 'italic';
			} else if (this.stylePhone.appearancePhone.fontStemItalic == 'italic') {
				this.stylePhone.appearancePhone.fontStemItalic = '';
			}
			this.sendmessage();
		},
		//题干 字体加粗
		setfontStemBold() {
			if (this.style.appearance.fontStemBold == '') {
				this.style.appearance.fontStemBold = 'bold';
			} else if (this.style.appearance.fontStemBold == 'bold') {
				this.style.appearance.fontStemBold = '';
			}
			this.sendmessage();
		},
		setfontStemBoldPhone() {
			if (this.stylePhone.appearancePhone.fontStemBold == '') {
				this.stylePhone.appearancePhone.fontStemBold = 'bold';
			} else if (this.stylePhone.appearancePhone.fontStemBold == 'bold') {
				this.stylePhone.appearancePhone.fontStemBold = '';
			}
			this.sendmessage();
		},
		//题干 字体颜色
		setfontStemColor(val) {
			this.style.appearance.fontStemColor = val;
			this.sendmessage();
		},
		setfontStemColorPhone(val) {
			this.stylePhone.appearancePhone.fontStemColor = val;
			this.sendmessage();
		},
		// 字体设置 题干大小
		setfontStemSize(item) {
			// console.log('itme项目题干', item);
			this.style.appearance.fontStemSize = item;
			this.sendmessage();
		},
		setfontStemSizePhone(item) {
			// console.log('itme项目题干', item);
			this.stylePhone.appearancePhone.fontStemSize = item;
			this.sendmessage();
		},
		//欢迎语 下划线
		setfontWelcomeUnderline() {
			if (this.style.appearance.fontWelcomeUnderline == '') {
				this.style.appearance.fontWelcomeUnderline = 'underline';
			} else if (this.style.appearance.fontWelcomeUnderline == 'underline') {
				this.style.appearance.fontWelcomeUnderline = '';
			}
			this.sendmessage();
		},
		setfontWelcomeUnderlinePhone() {
			if (this.stylePhone.appearancePhone.fontWelcomeUnderline == '') {
				this.stylePhone.appearancePhone.fontWelcomeUnderline = 'underline';
			} else if (this.stylePhone.appearancePhone.fontWelcomeUnderline == 'underline') {
				this.stylePhone.appearancePhone.fontWelcomeUnderline = '';
			}
			this.sendmessage();
		},
		//欢迎语 斜线
		setfontWelcomeItalic() {
			if (this.style.appearance.fontWelcomeItalic == '') {
				this.style.appearance.fontWelcomeItalic = 'italic';
			} else if (this.style.appearance.fontWelcomeItalic == 'italic') {
				this.style.appearance.fontWelcomeItalic = '';
			}
			this.sendmessage();
		},
		setfontWelcomeItalicPhone() {
			if (this.stylePhone.appearancePhone.fontWelcomeItalic == '') {
				this.stylePhone.appearancePhone.fontWelcomeItalic = 'italic';
			} else if (this.stylePhone.appearancePhone.fontWelcomeItalic == 'italic') {
				this.stylePhone.appearancePhone.fontWelcomeItalic = '';
			}
			this.sendmessage();
		},
		//欢迎语 加粗
		setfontWelcomeBold() {
			if (this.style.appearance.fontWelcomeBold == '') {
				this.style.appearance.fontWelcomeBold = 'bold';
			} else if (this.style.appearance.fontWelcomeBold == 'bold') {
				this.style.appearance.fontWelcomeBold = '';
			}
			this.sendmessage();
		},
		setfontWelcomeBoldPhone() {
			if (this.stylePhone.appearancePhone.fontWelcomeBold == '') {
				this.stylePhone.appearancePhone.fontWelcomeBold = 'bold';
			} else if (this.stylePhone.appearancePhone.fontWelcomeBold == 'bold') {
				this.stylePhone.appearancePhone.fontWelcomeBold = '';
			}
			this.sendmessage();
		},
		//欢迎语 字体颜色
		setfontWelcomeColor(val) {
			this.style.appearance.fontWelcomeColor = val;
			this.sendmessage();
		},
		setfontWelcomeColorPhone(val) {
			this.stylePhone.appearancePhone.fontWelcomeColor = val;
			this.sendmessage();
		},
		// 字体设置 欢迎语大小
		setfontWelcomeSize(item) {
			// console.log('itme项目标题', item);
			this.style.appearance.fontWelcomeSize = item;
			this.sendmessage();
		},
		setfontWelcomeSizePhone(item) {
			// console.log('itme项目标题', item);
			this.stylePhone.appearancePhone.fontWelcomeSize = item;
			this.sendmessage();
		},
		//项目 下划线
		setfontTitleUnderline() {
			if (this.style.appearance.fontTitleUnderline == '') {
				this.style.appearance.fontTitleUnderline = 'underline';
			} else if (this.style.appearance.fontTitleUnderline == 'underline') {
				this.style.appearance.fontTitleUnderline = '';
			}
			this.sendmessage();
		},
		setfontTitleUnderlinePhone() {
			if (this.stylePhone.appearancePhone.fontTitleUnderline == '') {
				this.stylePhone.appearancePhone.fontTitleUnderline = 'underline';
			} else if (this.stylePhone.appearancePhone.fontTitleUnderline == 'underline') {
				this.stylePhone.appearancePhone.fontTitleUnderline = '';
			}
			this.sendmessage();
		},
		//项目 斜体
		setfontTitleItalic() {
			if (this.style.appearance.fontTitleItalic == '') {
				this.style.appearance.fontTitleItalic = 'italic';
			} else if (this.style.appearance.fontTitleItalic == 'italic') {
				this.style.appearance.fontTitleItalic = '';
			}
			this.sendmessage();
		},
		setfontTitleItalicPhone() {
			if (this.stylePhone.appearancePhone.fontTitleItalic == '') {
				this.stylePhone.appearancePhone.fontTitleItalic = 'italic';
			} else if (this.stylePhone.appearancePhone.fontTitleItalic == 'italic') {
				this.stylePhone.appearancePhone.fontTitleItalic = '';
			}
			this.sendmessage();
		},
		//项目 加粗
		setfontTitleBold() {
			if (this.style.appearance.fontTitleBold == '') {
				this.style.appearance.fontTitleBold = 'bold';
			} else if (this.style.appearance.fontTitleBold == 'bold') {
				this.style.appearance.fontTitleBold = '';
			}
			this.sendmessage();
		},
		setfontTitleBoldPhone() {
			if (this.stylePhone.appearancePhone.fontTitleBold == '') {
				this.stylePhone.appearancePhone.fontTitleBold = 'bold';
			} else if (this.stylePhone.appearancePhone.fontTitleBold == 'bold') {
				this.stylePhone.appearancePhone.fontTitleBold = '';
			}
			this.sendmessage();
		},
		//项目颜色
		setfontTitleColor(val) {
			this.style.appearance.fontTitleColor = val;
			this.sendmessage();
		},
		setfontTitleColorPhone(val) {
			this.stylePhone.appearancePhone.fontTitleColor = val;
			this.sendmessage();
		},
		// 字体设置 项目标题     ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑
		setfontTitleSize(item) {
			// console.log('itme项目标题', item);
			this.style.appearance.fontTitleSize = item;
			this.sendmessage();
		},
		setfontTitleSizePhone(item) {
			// console.log('itme项目标题', item);
			this.stylePhone.appearancePhone.fontTitleSize = item;
			this.sendmessage();
		},
		// logo 位置设置
		setHTlogoLocation(item) {
			this.style.appearance.logoLocation = item;
			this.sendmessage();
		},
		setHTlogoLocationPhone(item) {
			this.stylePhone.appearancePhone.logoLocation = item;
			this.sendmessage();
		},
		// 删除logo 图片
		removelogoSet() {
			this.style.appearance.logoSet = '';
			this.sendmessage();
		},
		// 删除logo 图片
		removelogoSetPhone() {
			this.stylePhone.appearancePhone.logoSet = '';
			this.sendmessage();
		},
		//背景颜色
		setbgColor(item) {
			if (item == null) {
				item = '';
			}
			this.style.appearance.bgColor = item;
			this.sendmessage();
		},
		setbgColorPhone(item) {
			if (item == null) {
				item = '#FFFFFF';
			}
			this.stylePhone.appearancePhone.bgColor = item;
			this.sendmessage();
		},

		setbgOpacity(item) {
			this.style.appearance.bgOpacity = item;
			this.sendmessage();
		},
		setbgOpacityPhone(item) {
			this.stylePhone.appearancePhone.bgOpacity = item;
			this.sendmessage();
		},

		setbgQuestionnaire(item) {
			if (item == null) {
				item = '';
			}
			this.style.appearance.bgQuestionnaire = item;
			this.sendmessage();
		},
		setbgQuestionnairePhone(item) {
			if (item == null) {
				item = '';
			}
			this.stylePhone.appearancePhone.bgQuestionnaire = item;
			this.sendmessage();
		},
		setHTAdd(item) {
			console.log(item);
			this.style.appearance.bgLocation = item;
			this.sendmessage();
		},
		setHTAddPhone(item) {
			console.log(item);
			this.stylePhone.appearancePhone.bgLocation = item;
			this.sendmessage();
		},
		setHTImg(item) {
			if (item == 0) {
				this.style.appearance.bgColor = ''
			} else {
				this.style.appearance.bgImg = ''
			}
			// console.log('背景图片设置', item);
			this.style.appearance.bgState = item;
			this.sendmessage();
		},
		setHTImgPhone(item) {
			if (item == 0) {
				this.stylePhone.appearancePhone.bgColor = ''
			} else {
				this.stylePhone.appearancePhone.bgImg = ''
			}
			// console.log('背景图片设置', item);
			this.stylePhone.appearancePhone.bgState = item;
			this.sendmessage();
		},
		//删除 背景图片
		removebgImg() {
			this.style.appearance.bgImg = '';
			this.sendmessage();
		},
		//删除 手机背景图片
		removebgImgPhone() {
			this.stylePhone.appearancePhone.bgImg = '';
			this.sendmessage();
		},
		removeImg() {
			this.style.appearance.headerImg = '';
			this.sendmessage();
		},
		removeImgPhone() {
			this.stylePhone.appearancePhone.headerImg = '';
			this.sendmessage();
		},
		beforeAvatarUpload(file) {
			this.QiniuData.data = file;
		},
		// 上传图片成功
		handleSuccess(res) {
			// console.log('页眉图片', res);
			this.style.appearance.headerImg = res.message
			this.sendmessage();
		},
		handleSuccessPhone(res) {
			// console.log('页眉图片', res);
			this.stylePhone.appearancePhone.headerImg = res.message
			this.sendmessage();
		},
		handleRemove() {
			this.uploadPicUrl = '';
		},
		beforeAvatarUpload3(file) {
			this.QiniuData3.data = file;
		},
		handleSuccess3(res) {
			// console.log('33333333333', res);
			this.style.appearance.logoSet = res.message
			this.sendmessage();
		},
		handleSuccess3Phone(res) {
			// console.log('33333333333', res);
			this.stylePhone.appearancePhone.logoSet = res.message
			this.sendmessage();
		},
		handleRemove3() {
			this.uploadPicUrl = '';
		},
		beforeAvatarUpload2(file) {
			this.QiniuData2.data = file;
		},
		handleSuccess2(res) {
			// console.log('resqqqqqqqqqqqqq1', res);
			this.style.appearance.bgImg = res.message
			this.sendmessage();
		},
		handleSuccess2Phone(res) {
			// console.log('resqqqqqqqqqqqqq1', res);
			this.stylePhone.appearancePhone.bgImg = res.message
			this.sendmessage();
		},
		handleRemove2() {
			this.uploadPicUrl = '';
		},
		// 页眉背景颜色
		setheaderBgcolor(val) {
			this.style.appearance.headerBgcolor = val;
			this.sendmessage();
		},
		setheaderBgcolorPhone(val) {
			this.stylePhone.appearancePhone.headerBgcolor = val;
			this.sendmessage();
		},
		setheaderUnderline() {
			if (this.style.appearance.headerUnderline == '') {
				this.style.appearance.headerUnderline = 'underline';
			} else if (this.style.appearance.headerUnderline == 'underline') {
				this.style.appearance.headerUnderline = '';
			}
			this.sendmessage();
		},
		setheaderUnderlinePhone() {
			if (this.stylePhone.appearancePhone.headerUnderline == '') {
				this.stylePhone.appearancePhone.headerUnderline = 'underline';
			} else if (this.stylePhone.appearancePhone.headerUnderline == 'underline') {
				this.stylePhone.appearancePhone.headerUnderline = '';
			}
			this.sendmessage();
		},
		setheaderItalic() {
			if (this.style.appearance.headerItalic == '') {
				this.style.appearance.headerItalic = 'italic';
			} else if (this.style.appearance.headerItalic == 'italic') {
				this.style.appearance.headerItalic = '';
			}
			this.sendmessage();
		},
		setheaderItalicPhone() {
			if (this.stylePhone.appearancePhone.headerItalic == '') {
				this.stylePhone.appearancePhone.headerItalic = 'italic';
			} else if (this.stylePhone.appearancePhone.headerItalic == 'italic') {
				this.stylePhone.appearancePhone.headerItalic = '';
			}
			this.sendmessage();
		},
		// 页眉文字加粗
		setHeaderBold() {
			if (this.style.appearance.headerBold == '') {
				this.style.appearance.headerBold = 'bold';
			} else if (this.style.appearance.headerBold == 'bold') {
				this.style.appearance.headerBold = '';
			}
			this.sendmessage();
		},
		setHeaderBoldPhone() {
			if (this.stylePhone.appearancePhone.headerBold == '') {
				this.stylePhone.appearancePhone.headerBold = 'bold';
			} else if (this.stylePhone.appearancePhone.headerBold == 'bold') {
				this.stylePhone.appearancePhone.headerBold = '';
			}
			this.sendmessage();
		},
		// 页眉文字颜色
		setheaderColor(val) {
			this.style.appearance.headerColor = val;
			this.sendmessage();
			this.$util.request(params);
		},
		setheaderColorPhone(val) {
			this.stylePhone.appearancePhone.headerColor = val;
			this.sendmessage();
			// this.$util.request(params);
		},
		// 页眉文字大小
		setTitleSize(val) {
			// console.log('字体大小', val);
			this.style.appearance.headerSize = val;
			this.sendmessage();
		},
		setTitleSizePhone(val) {
			// console.log('字体大小', val);
			this.stylePhone.appearancePhone.headerSize = val;
			this.sendmessage();
		},
		headerAlign(item) {
			this.style.appearance.headerAlign = item;
			// console.log('输出内容', item);
			this.sendmessage();
		},
		headerAlignPhone(item) {
			this.stylePhone.appearancePhone.headerAlign = item;
			// console.log('输出内容', item);
			this.sendmessage();
		},
		setHeaderContent(item) {
			this.style.appearance.headerContent = item;
			this.sendmessage();
		},
		setHeaderContentPhone(item) {
			this.stylePhone.appearancePhone.headerContent = item;
			this.sendmessage();
		},
		disQuest(val) {
			this.style.appearance.displayQuestionsno = val;
			this.sendmessage();
		},
		diswel(val) {
			this.style.appearance.displayWelcome = val;
			this.sendmessage();
		},
		distitle(val) {
			this.style.appearance.displayTitle = val;
			this.sendmessage();
		},
		distitlePhone(val) {
			this.stylePhone.appearancePhone.displayTitle = val;
			this.sendmessage();
		},
		disQuestPhone(val) {
			this.stylePhone.appearancePhone.displayQuestionsno = val;
			this.sendmessage();
		},
		diswelPhone(val) {
			this.stylePhone.appearancePhone.displayWelcome = val;
			this.sendmessage();
		},
		btnText(val) {
			//提交按钮 PC端
			// console.log(val);
			this.style.appearance.buttonContent = val;
			this.sendmessage();
		},
		btnTextPhone(val) {
			//提交按钮手机端
			// console.log('提交按钮手机端' + val);
			this.stylePhone.appearancePhone.buttonContent = val;
			this.sendmessage();
		},
		setHT(val) {
			this.style.appearance.headerType = val;
			this.sendmessage();
			// console.log('111', this.style.appearance.headerType);
		},
		setHTPhone(val) {
			this.stylePhone.appearancePhone.headerType = val;
			this.sendmessage();
			// console.log('111', this.style.appearance.headerType);
		},
		setHeader(id) {
			this.style.appearance.headerState = id;
			this.sendmessage();
		},
		setHeaderPhone(id) {
			console.warn(this.stylePhone.appearancePhone)
			this.stylePhone.appearancePhone.headerState = id;
			this.sendmessage();
		},

		//  默认分类
		imgSet(item) {
			// // console.log(item);
			this.style.appearance.headerState = 1;
			this.style.appearance.headerImg = item;
			this.style.appearance.bgLocation = 1;
			this.style.appearance.headerType = 1;

			this.sendmessage();
		},
		imgSetPhone(item) {
			// // console.log(item);
			this.stylePhone.appearancePhone.headerState = 1;
			this.stylePhone.appearancePhone.headerImg = item;
			this.stylePhone.appearancePhone.bgLocation = 1;
			this.stylePhone.appearancePhone.headerType = 1;

			this.sendmessage();
		},

		// 主颜色下按钮颜色
		btnColor(index, item) {
			this.style.subjectColor = item.appearanceName;
			this.sendmessage();
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setsSubjectColor}`,
				method: 'POST',
				data: {
					id: that.wid,
					appearanceId: item.id
				},
				cb(res) {
					if (res.code == 0) {
						// console.log('主颜色设置成功', res);
					}
				}
			};
			this.$util.request(params);
		},
		// 主颜色下按钮颜色
		btnColorPhone(index, item) {
			this.stylePhone.subjectColor = item.appearanceName;
			this.stylePhone.appearancePhone.submitButtonColor = item.appearanceName;
			this.sendmessage();
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setsSubjectColor}`,
				method: 'POST',
				data: {
					id: that.wid,
					appearanceId: item.id
				},
				cb(res) {
					if (res.code == 0) {
						// console.log('主颜色设置成功', res);
					}
				}
			};
			this.$util.request(params);
		},
		sendmessage() {
			let that = this;
			if (that.tabPosition != 'phone') {
				let params = {
					that: this,
					url: `${this.$config.service.updateQuestionnaireStyle}`,
					method: 'POST',
					data: that.style.appearance,
					cb(res) {
						if (res.code == 0) {
							// console.log('成功修改Pc', res); //app
						}
					}
				};
				that.$util.request(params);
			}
			//保存手机端
			if (that.tabPosition == 'phone') {
				let params = {
					that: this,
					url: `${this.$config.service.updateQuestionnaireStyle}`,
					method: 'POST',
					data: that.stylePhone.appearancePhone,
					cb(res) {
						if (res.code == 0) {
							// console.log('手机端成功修改', res, that.stylePhone.appearancePhone); //app
						}
					}
				};
				that.$util.request(params);
			}
		},
		tabChange(e) {
			// console.log(e);
		},
		loadStyle() {
			//外观样式
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.selectAppearance}`,
				method: 'POST',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.resultBody = res.resultBody.datas;
					}
				}
			};
			this.$util.request(params);
		},
		loadAppear() {
			//外观内容
			let that = this;
			let id = that.wid;
			// console.log('输出wid', id);
			let params = {
				that: this,
				url: `${this.$config.service.selectQuestionnaire}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						that.style.appearance = res.resultBody.appearance; //pc 外观
						that.stylePhone.appearancePhone = res.resultBody.appearancePhone; //手机外观
						that.style.subjectColor = res.resultBody.subjectColor;
						that.stylePhone.subjectColor = res.resultBody.subjectColor;
						// console.log('style.app', that.style.appearance.headerState);
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style scoped lang="scss">
/deep/.share{
	display: none;
}
.mar {
	margin-left: 10px;
}
.tab_layout span {
	padding: 1px 7px;
	border: 1px solid #ccc;
}
.activeCheck {
	border: 1px solid #0080ff !important;
	color: #0080ff;
}
/deep/.el-collapse-item__content {
	padding-bottom: 0px !important;
}
.left {
	float: left;
}
.right {
	float: right;
	margin-right: 5px;
}
.heiSeting {
	width: 100%;
	height: 50px;
	line-height: 50px;
	background: #fafafa;
}
.computer-bj {
	width: 100%;
	height: auto;
}
.setFirst {
	width: 100%;
	height: 63px;
	border-bottom: 1px solid #e1e1e1;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.styleSet{
	padding-left: 10px;
	box-sizing: border-box;
	.el-collapse{
		border-top: 0;
	}
	.heiSeting{
		padding-left: 10px;
		box-sizing: border-box;
		.el-select{
			width: 100px;
		}
		.color-picker-box{
			width: 34px;
			height: 34px;
			display: inline-block;
			cursor: pointer;
			position: relative;
    		text-align: center;
			margin-left: 10px;
			border-radius: 4px;
			/deep/.el-icon-arrow-down:before{
				content: "";
			}
			.color-picker-A {
				width: 34px;
				height: 34px;
				position: absolute;
				left: 0;
				top: -1px;
				font-size: 18px;
				display: inline-block;
    			width: 100%;
				display: flex;
				align-items: center;  /* 垂直居中 */
				justify-content: center;
    			font-family: "Noto Serif SC", "思源宋体", serif;
			}
		}
		.fontSet{
			cursor: pointer;
			width: 30px;
			height: 30px;
			display: flex;
			align-items: center;  /* 垂直居中 */
			justify-content: center;
			border-radius: 4px;
			margin-left: 5px;
		}
		.fontSet-item:hover{
			background: #ecf5ff;
		}
		.fontSet-active{
			background: #d9ecff;
		}
	}
}
.wjAppearance_right_children {
	height: auto;
}
.classified_pictures {
	width: 258px;
	height: 72px;
	margin-left: 9px;
	margin-top: 17px;
}
/deep/.el-collapse-item__header {
	margin-left: 0 !important;
}
/deep/.drop-down-display .el-collapse-item__header {
	height: 68px !important;
	line-height: 68px !important;
	font-size: 16px !important;
	text-indent: 28px !important;
}
/deep/.drop-down-display .el-collapse-item__arrow.is-active {
	margin: 0 8px 28px auto;
}
.color_btn_box {
	display: flex;
	flex-wrap: wrap;
}
.color_btn_box button {
	outline: none;
	border: none;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	margin-right: 10px;
	margin-top: 15px;
}
.phone-bj-box {
	height: 721px;
    border-radius: 18px;
    overflow-y: scroll;
	scrollbar-width: none;
    -ms-overflow-style: none;
    overflow-x: hidden;
}
.phone-bj-box::-webkit-scrollbar{
	width: 0;
}
.phone-bj {
	width: 375px;
	border-radius: 25px;
	border: 5px solid #ccc;

	/* width: 400px;
	height: 756px;
	background: url('../../assets/iphone.png') no-repeat center;
	background-size: 100% 100%; */
	/* overflow: hidden; */
}
.phoneBox {
	margin-top: 15px;
	display: flex;
	justify-content: center;
}
.computerBox {
	flex: 1;
	width: 100%;
	display: flex;
	margin-top: 30px;
	/* margin-left: 100px; */
}
.tab {
	padding-top: 10px;
	/* height: 200px; */
	margin: auto;
}
.wjColor_children i {
	color: #fff;
}
.wjColor_children {
	margin-left: 29px;
	padding-top: 19px;
}
.wjColor_box {
	width: 100%;
	height: 188px;
	background-color: #fff;
}
.wjAppearance_left {
    width: 278px;
    height: 100%;
    position: fixed;
    top: 60px;
    left: 81px;
    z-index: 100;
    background: #fff;
}
.wjAppearance_right {
	width: 360px;
	height: 100%;
	background-color: #fff;
	position: fixed;
	top: 60px;
	right: 16px;
}
.wjAppearance_center {
	margin-left: 278px;
	margin-right: 360px;
	width: 100%;
	justify-content: center;
	/* width: calc(100% - 278px- 360px); */
	float: left;
	display: flex;
	flex-direction: column;
}
.wjappearance {
	/* width: 100%-80px;*/
	/* height: 600px; */
	// margin-left: 82px;
	display: flex;
	justify-content: space-between;
	// margin-top: 62px;
}
.el-radio-group {
	margin: 0 auto;
}

/deep/.aaaaa .el-color-picker {
	width: 34px !important;
	height: 30px !important;
}
/deep/ .aaaaa .el-color-picker__color {
	border: none !important;
	// background-image: url('../../../public/img/ztsz.png');
	background-repeat: no-repeat;
}
/deep/ .aaaaa .el-color-picker__trigger {
	border: none !important;
	background: transparent;
}
/deep/ .aaaaa .el-color-picker__empty {
	width: 16px;
	height: 19px;
}
/deep/ .aaaaa .el-color-picker__color-inner {
	display: none;
}
/deep/ .el-icon-close:before {
	content: none;
}
.aaaaa {
	/* position: absolute; */
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.imga {
	position: relative;
	top: 0;
	left: -28px;
	z-index: -99;
}
</style>
